<ng-container *transloco="let t">
  <ng-container *ngFor="let v of values$ | async">
    <div *ngIf="v.deliveryPointCode || v.deliveryPointName">
      <label class="mr-1">{{t('select-department-report.deliveryPoint')}}:</label>
      <span class="font-weight-bold">{{v.deliveryPointCode}} - {{v.deliveryPointName}}</span>
    </div>
    <div *ngIf="v.departmentCode || v.departmentName">
      <label class="mr-1">{{t('select-department-report.department')}}:</label>
      <span class="font-weight-bold">{{v.departmentCode}} - {{v.departmentName}}</span>
    </div>
  </ng-container>
</ng-container>
